module.exports = __webpack_public_path__ + "img/process-diagram.0aa80651.svg";